import { useEffect, useState } from 'react';
import { useUndo } from '../../context/UndoContext';

const TOAST_DURATION_MS = 10_000;

export default function UndoToast() {
  const { latestToast, dismissToast, undoById, enabled } = useUndo();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!latestToast) return;
    const t = window.setTimeout(() => {
      dismissToast();
    }, TOAST_DURATION_MS);
    return () => window.clearTimeout(t);
  }, [latestToast, dismissToast]);

  if (!enabled || !latestToast) return null;

  const onUndo = async () => {
    setBusy(true);
    try {
      await undoById(latestToast.id);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-slate-900 text-white px-4 py-3 rounded-lg shadow-xl border border-slate-700"
      role="status"
      aria-live="polite"
    >
      <span className="text-sm">{latestToast.label}</span>
      <button
        type="button"
        onClick={onUndo}
        disabled={busy}
        className="btn btn-text text-blue-300 enabled:hover:text-blue-200 font-semibold text-sm"
      >
        {busy ? 'Wird rückgängig gemacht…' : 'Rückgängig (Strg+Z)'}
      </button>
      <button
        type="button"
        onClick={dismissToast}
        className="text-slate-400 hover:text-white text-lg leading-none px-1"
        aria-label="Schließen"
      >
        ×
      </button>
    </div>
  );
}
